import { defineMessages } from 'react-intl';

export default defineMessages({
  todoFilterOption: {
    id: 'frontbucket.jiraTab.issueCategoryFilterOption.todo',
    description: 'Filter option label for issue category "To do".',
    defaultMessage: 'To do',
  },
  inProgressFilterOption: {
    id: 'frontbucket.jiraTab.issueCategoryFilterOption.inProgressFilterOption',
    description: 'Filter option label for issue category "In progress".',
    defaultMessage: 'In progress',
  },
  doneFilterOption: {
    id: 'frontbucket.jiraTab.issueCategoryFilterOption.doneFilterOption',
    description: 'Filter option label for issue category "Done".',
    defaultMessage: 'Done',
  },
  issueCategoryFilterDropdownLabel: {
    id: 'frontbucket.jiraTab.issueCategoryFilterDropdownLabel',
    description: 'Label for the issue category filter dropdown label.',
    defaultMessage: 'Status',
  },
  issueCategoryFilterGroupHeader: {
    id: 'frontbucket.jiraTab.issueCategoryFilterGroupHeader',
    description: 'Label for the issue category options group header.',
    defaultMessage: 'Categories',
  },
  issueCategoryFilterTooltipText: {
    id: 'frontbucket.jiraTab.issueCategoryFilterGroupTooltip',
    description: 'Tooltip text for the issue category filter.',
    defaultMessage: 'Status category',
  },
});
